export enum FileIconType {
  Video = 'play',
  Img = 'image',
  Doc = 'pdf'
}



// WEBPACK FOOTER //
// ./src/app/models/file-icon-type.enum.ts